/* eslint-disable */
// /src/pages/FranchiseApplyPage.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Container from "../components/Container";
import { useNavigate } from "react-router-dom";
import carVisual from "../assets/images/car_kakaot.png";
import { useAppConfig } from "../context/AppConfigContext";

const Wrap = styled.div`
  min-height: 100vh;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  background: #fff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

const TopBar = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-bottom: 1px solid #f2f2f2;

  button {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    color: #111;
    font-weight: 700;
    padding: 6px 8px;
    border-radius: 10px;
  }

  button:active {
    transform: translateY(1px);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

const Middle = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 20px 16px 0;
`;

const Content = styled.div`
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeaderWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${({ $mt }) => ($mt != null ? $mt : 60)}px;
  margin-bottom: 18px;
  min-height: 72px;
`;

const HeaderImg = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

const ChoiceSection = styled.div`
  width: 100%;
  margin-top: ${({ $mt }) => ($mt != null ? $mt : 32)}px;
`;

const ChoiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
`;

const Choice = styled.button`
  height: 110px;
  border: 0;
  border-radius: 18px;
  cursor: pointer;
  background: ${({ $bg }) => $bg || "#c9f2ee"};
  color: ${({ $color }) => $color || "#111"};
  font-weight: 900;
  font-size: 28px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  transition: transform 0.06s ease, box-shadow 0.12s ease;

  &:active {
    transform: translateY(1px);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  }
`;

const CarSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${({ $mt }) => ($mt != null ? $mt : 40)}px;
`;

const CarWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  min-height: 180px;

  img {
    width: min(680px, 92vw);
    max-height: 38vh;
    object-fit: contain;
    display: block;
  }
`;

const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

const SpinnerWrap = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: #999;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default function FranchiseApplyPage() {
  const navigate = useNavigate();
  const { config, loading } = useAppConfig();
  const detail = config.detailScreens || {};
  const franchise = detail.franchiseApply || {};

  const layout = franchise.layout || {};
  const headerImg = franchise.headerImg || "";
  const carImg = franchise.carImg || carVisual;

  const buttonsFromConfig =
    Array.isArray(franchise.buttons) && franchise.buttons.length > 0
      ? franchise.buttons
      : [
        {
          id: "personal",
          label: "개인",
          bgColor: "#a6aff2",
          textColor: "#111827",
        },
        {
          id: "corporate",
          label: "법인",
          bgColor: "#a7f3d0",
          textColor: "#111827",
        },
      ];

  const [imagesReady, setImagesReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const urls = [headerImg, carImg].filter(Boolean);
    if (!urls.length) {
      setImagesReady(true);
      return undefined;
    }

    let loaded = 0;
    urls.forEach((src) => {
      const img = new Image();
      img.onload = img.onerror = () => {
        if (cancelled) return;
        loaded += 1;
        if (loaded === urls.length) {
          setImagesReady(true);
        }
      };
      img.src = src;
    });

    return () => {
      cancelled = true;
    };
  }, [headerImg, carImg]);

  const ready = !loading && imagesReady && buttonsFromConfig.length > 0;

  const handleChoiceClick = (id) => {
    if (id === "personal") {
      navigate("/franchise/apply/personal");
    } else if (id === "corporate") {
      navigate("/franchise/apply/corporate");
    } else {
      console.warn("[FranchiseApply] unknown button id:", id);
    }
  };

  return (
    <Wrap>
      <Container noPadding full>
        <Body>
          <TopBar>
            <button onClick={() => navigate("/home")} aria-label="홈으로 이동">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="#111"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 11.5L12 4l9 7.5" />
                <path d="M5 10.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9.5" />
              </svg>
              홈으로 이동
            </button>
          </TopBar>

          {!ready && (
            <SpinnerWrap>
              <Spinner />
            </SpinnerWrap>
          )}

          {ready && (
            <>
              <Middle>
                <Content>
                  {headerImg && (
                    <HeaderWrap $mt={layout.headerTop}>
                      <HeaderImg
                        src={headerImg}
                        alt="kakaoT Hey’ Way 가맹가입"
                      />
                    </HeaderWrap>
                  )}

                  <ChoiceSection $mt={layout.buttonsTop}>
                    <ChoiceGrid>
                      {buttonsFromConfig.map((btn) => (
                        <Choice
                          key={btn.id}
                          onClick={() => handleChoiceClick(btn.id)}
                          $bg={btn.bgColor}
                          $color={btn.textColor}
                        >
                          {btn.label}
                        </Choice>
                      ))}
                    </ChoiceGrid>
                  </ChoiceSection>

                  <CarSection $mt={layout.carTop}>
                    <CarWrap>
                      <img src={carImg} alt="Hey’ Way Vehicle" />
                    </CarWrap>
                  </CarSection>
                </Content>
              </Middle>

              <BottomPad />
            </>
          )}
        </Body>
      </Container>
    </Wrap>
  );
}
